var _slicedToArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

module.exports = function (e) {
  var t = {};

  function o(r) {
    if (t[r]) return t[r].exports;
    var n = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(n.exports, n, n.exports, o), n.l = !0, n.exports;
  }

  return o.m = e, o.c = t, o.d = function (e, t, r) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (e, t) {
    if (1 & t && (e = o(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var n in e) {
      o.d(r, n, function (t) {
        return e[t];
      }.bind(null, n));
    }
    return r;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 75);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  3: function _(e, t) {
    e.exports = require("../../styles");
  },
  5: function _(e, t) {
    e.exports = require("../Icon/Icon");
  },
  75: function _(e, t, o) {
    "use strict";

    var r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var o in e) {
        Object.hasOwnProperty.call(e, o) && (t[o] = e[o]);
      }
      return t.default = e, t;
    },
        n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = r(o(1)),
        l = r(o(2)),
        a = n(o(8)),
        s = o(3),
        u = n(o(5)),
        d = s.colorPalettes.KineduPalette,
        c = l.default.div.attrs(function () {
      return {
        className: "header"
      };
    })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-shrink: 0;\n\n  width: 100%;\n  height: ", ";\n  background-color: ", ";\n  padding: 0 20px;\n  box-sizing: border-box;\n\n  color: white;\n  font-size: 24px;\n  font-weight: bold;\n"])), function (_ref) {
      var e = _ref.headerHeight;
      return e + "px";
    }, d.newKinedu),
        f = l.default.div.attrs(function () {
      return {
        className: "content"
      };
    })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n"]))),
        p = l.default.div.attrs(function () {
      return {
        className: "backdrop"
      };
    })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  position: fixed;\n  z-index: 9999998;\n  pointer-events: none;\n  background-color: rgba(0,0,0,0);\n  transition: 0.3 all ease;\n\n  ", ";\n"])), s.globalStyles.fillAbsoluteSpace, function (_ref2) {
      var e = _ref2.show;
      return e && l.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    pointer-events: all;\n    background-color: rgba(0,0,0,0.4);\n  "])));
    }),
        h = l.default.div.attrs(function () {
      return {
        className: "lego-sideview"
      };
    })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: -580px;\n  display: flex;\n  flex-direction: column;\n\n  width: 100%;\n  height: 100%;\n  max-width: 580px;\n  background-color: white;\n  box-shadow: 0 0 30px -10px #00000030;\n  max-width: ", ";\n\n  transition: all ease 0.5s;\n  z-index: 9999999;\n  overflow-y:  ", ";\n\n  ", ";\n"])), function (_ref3) {
      var e = _ref3.maxWidth;
      return "number" == typeof e ? e + "px" : e;
    }, function (_ref4) {
      var e = _ref4.overflowY;
      return e;
    }, function (_ref5) {
      var e = _ref5.show;
      return e && l.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    right: 0;\n  "])));
    }),
        x = l.default(u.default).attrs(function (_ref6) {
      var e = _ref6.color;
      return {
        name: "close",
        color: e,
        size: 32
      };
    })(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 10px;\n  right: 15px;\n\n  height: 30px;\n  width: 30px;\n  padding: 4px;\n\n  box-sizing: border-box;\n  cursor: pointer;\n  z-index: 1;\n"]))),
        b = function b(_ref7) {
      var e = _ref7.show,
          t = _ref7.children,
          o = _ref7.onClose,
          r = _ref7.maxWidth,
          _ref7$headerHeight = _ref7.headerHeight,
          n = _ref7$headerHeight === void 0 ? 64 : _ref7$headerHeight,
          l = _ref7.headerRender,
          s = _ref7.title,
          u = _ref7.showCloseButton,
          b = _ref7.closeButtonColor,
          g = _ref7.overflowY;

      var _i$useState = i.useState(!1),
          _i$useState2 = _slicedToArray(_i$useState, 2),
          m = _i$useState2[0],
          w = _i$useState2[1];

      i.useEffect(function () {
        w(e);
      }, [e]);

      var v = function v() {
        w(!1), o && o();
      };

      return i.default.createElement(a.default, {
        rootId: "sideview-root"
      }, i.default.createElement(p, {
        onClick: v,
        show: m
      }, i.default.createElement(h, {
        show: m,
        maxWidth: r,
        overflowY: g,
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, u && i.default.createElement(x, {
        onClick: v,
        color: b || d.shadeMedium
      }), s ? i.default.createElement(c, {
        headerHeight: n
      }, l || s) : null, i.default.createElement(f, null, t))));
    };

    b.defaultProps = {
      show: !1,
      showCloseButton: !0,
      onClose: function onClose() {},
      overflowY: "scroll"
    }, t.default = b;
  },
  8: function _(e, t) {
    e.exports = require("../Portal/Portal");
  }
});